import {
    Divider,
    Flex,
    InfoIcon,
    Skeleton,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";
import { CalendarClockRegular } from "@fluentui/react-icons";
import DialogRecoveryYearly from "../../Dialogs/DialogRecoveryYearly/DialogRecoveryYearly";
import { format_number } from "../../../constants/maths";
import { DEVICE_MAX } from "../../../constants/responsive";

const CardAnnualRecovery = ({
    actualSolde,
    totalAcquired,
    compensated,
    hoursCountPerDay,
    actualSoldeInDays,
    totalAcquiredInDays,
    compensatedInDays,
    isLoading = false,
}) => {
    const f_actual_solde =
        actualSolde > 0
            ? "+ " + format_number(actualSolde)
            : format_number(actualSolde);

    return (
        <Card column gap="gap.medium">
            <Flex vAlign="center" gap="gap.smaller" space="between" fill>
                <Flex vAlign="center" gap="gap.smaller">
                    <CalendarClockRegular
                        fontSize={14}
                        color={"var(--color-primary)"}
                    />
                    <STextRecuperation content="Récupération annuelle" />
                </Flex>
                <Flex vAlign="center">
                    <DialogRecoveryYearly
                        actualSolde={actualSolde}
                        totalAcquired={totalAcquired}
                        compensated={compensated}
                        hoursCountPerDay={hoursCountPerDay}
                        actualSoldeInDays={actualSoldeInDays}
                        totalAcquiredInDays={totalAcquiredInDays}
                        compensatedInDays={compensatedInDays}
                    />
                </Flex>
            </Flex>
            <Flex column vAlign="center" fill>
                <Flex>
                    {isLoading ? (
                        <Skeleton animation="pulse">
                            <Skeleton.Line width="90px" height="26px" />
                        </Skeleton>
                    ) : (
                        <HoursText>{f_actual_solde}</HoursText>
                    )}
                </Flex>
            </Flex>
            <Flex vAlign="center" gap="gap.smaller">
                {isLoading ? (
                    <Skeleton animation="pulse">
                        <Skeleton.Line width="120px" height="26px" />
                    </Skeleton>
                ) : (
                    <STextDetail>soit {actualSoldeInDays}</STextDetail>
                )}
                <Tooltip
                    content={isLoading ? "" : `1 j = ${hoursCountPerDay} h`}
                    subtle={false}
                    trigger={<InfoIcon outline size="small" />}
                    pointing
                    position="before"
                    align="center"
                />
            </Flex>
        </Card>
    );
};

export default CardAnnualRecovery;

const STextDetail = styled(Text)`
    font-size: 11px;
    color: var(--text-tert);
`;

export const HoursText = styled(Text)`
    font-size: 28px;
    font-weight: 700;
    color: var(--purple);
    display: flex;
    gap: 2px;
    align-items: baseline;
    ::after {
        content: "${({ unit }) => (unit ? unit + "" : "h")}";
        font-size: 13px;
        font-weight: 400;
        color: var(--text-tert);
    }
`;

export const STextRecuperation = styled(Text)`
    font-size: 12px;
    color: var(--text-sec);
    white-space: nowrap;
    line-height: 1;
`;

export const Card = styled(Flex)`
    border: 1.5px solid var(--purple-chip);
    border-radius: 8px;
    padding: 12px 18px 14px;
    min-width: 148px;
    background: white;
    display: grid;
    grid-template-rows: 20px 36px auto;
    gap: 6px;
    align-content: center;

    @media ${DEVICE_MAX.mobile} {
        width: 100%;
        min-width: 0;
    }
`;
